import { useStores } from '../../hooks/stores';

export const useAuthStore = () => {
  const { authStore } = useStores();
  return authStore;
};
